import { theme } from '@primer/react';
import { TreeView } from '@primer/react/drafts';
import ThemeReferenceTree from "../../../../components/ThemeReferenceTree";
import * as React from 'react';
export default {
  theme,
  TreeView,
  ThemeReferenceTree,
  React
};